import _extends from "@babel/runtime/helpers/extends";
import { App, ConfigProvider } from "antd";
import { RootStore } from "../store";
import { IconProvider } from "@ant-design/icons";
const Provider = _ref => {
  let {
    children,
    configProvider = {},
    app = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(ConfigProvider, _extends({
    prefixCls: process.env.ANTD_PREFIX,
    iconPrefixCls: `${process.env.ANTD_PREFIX}-anticon`,
    theme: {
      token: {
        colorPrimary: "#2271b1",
        borderRadius: 3
      }
    }
  }, configProvider), /*#__PURE__*/React.createElement(IconProvider, {
    value: {
      prefixCls: `${process.env.ANTD_PREFIX}-anticon`
    }
  }, /*#__PURE__*/React.createElement(App, _extends({
    message: {
      top: 50
    }
  }, app), /*#__PURE__*/React.createElement(RootStore.StoreProvider, null, children))));
};
export { Provider };